'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './landusemap.routes';


export class LandusemapComponent {
  /*@ngInject*/
  constructor(
    $http,
    $scope,
    $location,
    $timeout,
    $state,
    lookup,
    mapService,
    theme,
    dbFactory,
    db
  ) {
    // Angular classes
    this.$http = $http;
    this.$location = $location;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$state = $state;

    //Load services
    this.lookup = lookup;
    this.mapService = mapService;
    this.theme = theme;
    this.dbFactory = dbFactory;
    this.db = db;

    this.$scope.loadAllCounties = false;
    this.$scope.hessTract = {};
    this.$scope.showMoreFilters = false;





    this.$scope.affhPercent = ['zero_fifty_ami',
      'fifty_eighty_ami',
      'eighty_hundred_ami',
      'hundred_ami',
      'percent_people_of_color',
      'non_hispanic_black',
      'non_hispanic_white',
      'non_hispanic_api',
      'non_hispanic_other',
      'hispanic_latinx',
      'disability_status',
      'family_households',
      'non_family_households',
      'single_person_households',
      'households_with_children',
      'costburdened_housing',
      'overcrowded_housing',
      'substandard_housing']
      

    // Global Variables
    this.$scope.selectedCounty = "Region";
    this.$scope.selectedJurisdiction = "Region";
    this.$scope.selectedRecords = [];
    this.$scope.removeRecords = [];
    this.$scope.addRecords = [];
  
    this.$scope.filterLength = 1;
    this.$scope.actionsLength = 0;
    this.$scope.filterParcels = [];
    this.$scope.selectedParcels = [];
    this.$scope.myListParcels = [];


   
    // this.$scope.mapLoading = true;

    this.$scope.counties = [
      {
        FIPS: "CA000",
        County: "Region",
      },
      {
        FIPS: "CA001",
        County: "Alameda",
      },
      {
        FIPS: "CA013",
        County: "Contra Costa",
      },
      {
        FIPS: "CA041",
        County: "Marin",
      },
      {
        FIPS: "CA055",
        County: "Napa",
      },
      {
        FIPS: "CA075",
        County: "San Francisco",
      },
      {
        FIPS: "CA081",
        County: "San Mateo",
      },
      {
        FIPS: "CA085",
        County: "Santa Clara",
      },
      {
        FIPS: "CA095",
        County: "Solano",
      },
      {
        FIPS: "CA097",
        County: "Sonoma",
      },
    ];

          //Socrata Data 
    this.$scope.countyClusterData = [
      {
        county: 'Alameda',
        dataset: '93se-xg39'
      },{
        county: 'Contra Costa',
        dataset: 'vuut-natu'
      },{
        county: 'Marin',
        dataset: 'vjkr-53hr'
      },{
        county: 'Napa',
        dataset: 'g4fh-b8ig'
      },{
        county: 'San Francisco',
        dataset: 't3gh-9cx3'
      },{
        county: 'San Mateo',
        dataset: 'nbzd-yjgf/'
      },{
        county: 'Santa Clara',
        dataset: 'h4tw-qqi4'
      },{
        county: 'Solano',
        dataset: 'qxvs-erv6'
      },{
        county: 'Sonoma',
        dataset: 'jq8v-6ure'
      }]

    // Set query geometry name (either point for counties, or geometry for region)
    this.$scope.params = 'geometry';
    
    this.$scope.regional_zoning_lu = [{"zn_regional_code":"1.0","zn_regional_description":"Agriculture"}
    ,{"zn_regional_code":"6.0","zn_regional_description":"Commercial"}
    ,{"zn_regional_code":"11.0","zn_regional_description":"Conservation and Ecology Areas"}
    ,{"zn_regional_code":"7.0","zn_regional_description":"Industrial"}
    ,{"zn_regional_code":"5.0","zn_regional_description":"Mixed Use Commercial"}
    ,{"zn_regional_code":"4.0","zn_regional_description":"Mixed Use Residential"}
    ,{"zn_regional_code":"3.0","zn_regional_description":"Multi-Family Residential"}
    ,{"zn_regional_code":"9.0","zn_regional_description":"Parks and Open Space"}
    ,{"zn_regional_code":"10.0","zn_regional_description":"Public and Institutional"}
    ,{"zn_regional_code":"2.0","zn_regional_description":"Single Family Residential"}
    ,{"zn_regional_code":"12.0","zn_regional_description":"Specific or Special Plan Areas"}
    ,{"zn_regional_code":"8.0","zn_regional_description":"Transportation"}
    ,{"zn_regional_code":"999.0","zn_regional_description":"Unclassified"}];
    

    this.$scope.existing_use_lu = [{"existing_use_description":"Agricultural/open space"}
    ,{"existing_use_description":"Agriculture"}
    ,{"existing_use_description":"Commercial"}
    ,{"existing_use_description":"Commercial Office"}
    ,{"existing_use_description":"Educational/institutional/religious"}
    ,{"existing_use_description":"Forest and Rangeland"}
    ,{"existing_use_description":"Heavy Industrial and Utility"}
    ,{"existing_use_description":"Hotel/motel"}
    ,{"existing_use_description":"Industrial"}
    ,{"existing_use_description":"Light Industrial and Warehouse"}
    ,{"existing_use_description":"Medical Parks and Hospitals"}
    ,{"existing_use_description":"Military Lands"}
    ,{"existing_use_description":"Mining and Extractive"}
    ,{"existing_use_description":"Mixed Use"}
    ,{"existing_use_description":"Mixed Use Commercial"}
    ,{"existing_use_description":"Mixed Use Residential"}
    ,{"existing_use_description":"Mobile Home Park"}
    ,{"existing_use_description":"Multifamily Residential"}
    ,{"existing_use_description":"Parking"}
    ,{"existing_use_description":"Park Recreational or Preserve"}
    ,{"existing_use_description":"Public and Institutional"}
    ,{"existing_use_description":"Public facilities"}
    ,{"existing_use_description":"Residential"}
    ,{"existing_use_description":"Retail and Other Commercial"}
    ,{"existing_use_description":"Single Family Residential"}
    ,{"existing_use_description":"Transportation"}
    ,{"existing_use_description":"Vacant"}
    ,{"existing_use_description":"Vacant or Undeveloped"}
    ,{"existing_use_description":"Wetlands or Water"}]

  
    

    this.$scope.filterTextValues = []
    

    this.$scope.addSitesList = [];

    this.$scope.zoomSpinner = false;
  }

  $onInit() {
   

    // Get lookup values for infrastructure access 
    this.$scope.infrastructureAccessLU = this.lookup.getInfrastructureAccess();

    // Show data disclaimer 
    var modalCheck = this.lookup.getModalCheck('map');
    // console.log(modalCheck);
    if(!modalCheck){
      $('#dataDisclaimerModal').modal();
      this.lookup.setModalCheck('map', true);
    }
    
    if (this.$location.search().parcel_id) {
      // console.log(this.$location.search());
      this.$scope.dataParcel_id = this.$location.search().parcel_id;
    }

    //Load theme functions
    this.theme.initTheme();

    // Get sources
    this.$http.get('https://data.bayareametro.gov/resource/7rg3-3vjs.json')
      .then(response => {
      // console.log(response.data);
      // Removed since I am no longer showing the dataset description here.
      // response.data.forEach(element => {
      //   element.intro = element.dataset_description.slice(0,200) + '...';
      // });
        this.$scope.environmentalConstraints = _.filter(response.data, {data_category: 'Environmental Constraint'});
        this.$scope.basicInformation = _.filter(response.data, {data_category: 'Basic Information'});
        this.$scope.planningConsiderations = _.filter(response.data, {data_category: 'Planning Consideration'});
        this.$scope.landuseAttributes = _.filter(response.data, {data_category: 'Land Use Information'});
        this.$scope.affh = _.filter(response.data, {data_category: 'Affirmatively Furthering Fair Housing'}); // NEW
        this.$scope.hcd = _.filter(response.data, {data_category: 'HCD Housing Sites Inventory'}); // NEW
      console.log(this.$scope.environmentalConstraints)
      })
      .catch(err => {
        console.log(err);
      });

    //Get list of toggle map layers [Map Service]
    this.$scope.mapLayers = this.mapService.getMapLayers();

    this.loadMap("Region");

    this.loadCountyList();

    // Default Values
    this.$scope.filter = {
      in_cycle6: true
    };

    this.updateFilterLength();
  }

  loadLayerDetails(data) {
    console.log("success");
    this.lookup.setDataDetail(data);
    this.$state.go('detail');
  }

  loadMap() {
    // console.log("running load map");
    // $('#loading').show();
    // Reset prescreening layer counts
    this.$scope.hessSummaryTotal = [];
    var map;

    var $scope = this.$scope;
    var $http = this.$http;
    var lookup = this.lookup;
    var $location = this.$location;
    // var city = this.$scope.selectedJurisdiction;
    var updateInfoBox = this.updateInfoBox;
    var dbFactory = this.dbFactory;
    this.$scope.toggleMapLayer = this.toggleMapLayer;
    this.$scope.selectedRecords = [];
    var selectedRecords = [];
    var addSitesList = [];
    var listRecords = $scope.listRecords;
    var mapService = this.mapService;
    var updateMap = this.updateMap;

    this.$scope.isItLoaded = false;
    
    // Zoom threshold
    const zoomThreshold = 4;

    this.$scope.removeRecords = [];
    var removeRecords = [];

    this.$scope.addRecords = [];
    var addRecords = [];
    var rowSelectedCollection = [];

    // define map
    mapboxgl.accessToken =
      "pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNranVpYWNqeTFtMHEyeXRjdjFnN2lldTUifQ.09JACeDB27_PEaebVWA9rA";
    map = new mapboxgl.Map({
      container: "map", // container id
      style: "mapbox://styles/mapbox/light-v10", // stylesheet location
      zoom: 8,
      center: [-122.275051, 37.796966], //Set center based on geojson feature
    });
   
   

    map.addControl(
      new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,

        // limit results to US
        countries: "us",

        // further limit results to the geographic bounds representing the region of
        // California
        // bbox: [139.965, -38.03, 155.258, -27.839],

        // apply a client side filter to further limit results to those strictly within
        // the California region
        filter: function (item) {
          // returns true if item contains California region
          return item.context
            .map(function (i) {
              // id is in the form {index}.{id} per https://github.com/mapbox/carmen/blob/master/carmen-geojson.md
              // this example attempts to find the `region` named `California`
              return (
                i.id.split(".").shift() === "region" && i.text === "California"
              );
            })
            .reduce(function (acc, cur) {
              return acc || cur;
            });
        },
        mapboxgl: mapboxgl,
      })
    );

    // code for creating an SVG donut chart from feature properties
    function createDonutChart(props) {
      const offsets = [];
      const counts = [
        props.mag1,
        props.mag2,
        props.mag3,
        props.mag4,
        props.mag5,
      ];
      let total = 0;
      for (const count of counts) {
        offsets.push(total);
        total += count;
      }
      const fontSize =
        total >= 1000 ? 22 : total >= 100 ? 20 : total >= 10 ? 18 : 16;
      const r = total >= 1000 ? 50 : total >= 100 ? 32 : total >= 10 ? 24 : 18;
      const r0 = Math.round(r * 0.6);
      const w = r * 2;

      let html = `<div>
          <svg width="${w}" height="${w}" viewbox="0 0 ${w} ${w}" text-anchor="middle" style="font: ${fontSize}px sans-serif; display: block">`;

      for (let i = 0; i < counts.length; i++) {
        html += donutSegment(
          offsets[i] / total,
          (offsets[i] + counts[i]) / total,
          r,
          r0,
          colors[i]
        );
      }
      html += `<circle cx="${r}" cy="${r}" r="${r0}" fill="white" />
          <text dominant-baseline="central" transform="translate(${r}, ${r})">
          ${total.toLocaleString()}
          </text>
          </svg>
          </div>`;

      const el = document.createElement("div");
      el.innerHTML = html;
      return el.firstChild;
    }

    function donutSegment(start, end, r, r0, color) {
      if (end - start === 1) end -= 0.00001;
      const a0 = 2 * Math.PI * (start - 0.25);
      const a1 = 2 * Math.PI * (end - 0.25);
      const x0 = Math.cos(a0),
        y0 = Math.sin(a0);
      const x1 = Math.cos(a1),
        y1 = Math.sin(a1);
      const largeArc = end - start > 0.5 ? 1 : 0;

      // draw an SVG path
      return `<path d="M ${r + r0 * x0} ${r + r0 * y0} L ${r + r * x0} ${
        r + r * y0
      } A ${r} ${r} 0 ${largeArc} 1 ${r + r * x1} ${r + r * y1} L ${
        r + r0 * x1
      } ${r + r0 * y1} A ${r0} ${r0} 0 ${largeArc} 0 ${r + r0 * x0} ${
        r + r0 * y0
      }" fill="${color}" />`;
    }

    // objects for caching and keeping track of HTML marker objects (for performance)
    const markers = {};
    let markersOnScreen = {};

    function updateMarkers(map) {
      const newMarkers = {};
      const features = map.querySourceFeatures("parcel-units");

      // for every cluster on the screen, create an HTML marker for it (if we didn't yet),
      // and add it to the map if it's not there already
      for (const feature of features) {
        const coords = feature.geometry.coordinates;
        const props = feature.properties;
        if (!props.cluster) continue;
        const id = props.cluster_id;

        let marker = markers[id];
        if (!marker) {
          const el = createDonutChart(props);
          marker = markers[id] = new mapboxgl.Marker({
            element: el,
          }).setLngLat(coords);
        }
        newMarkers[id] = marker;

        if (!markersOnScreen[id]) marker.addTo(map);
      }
      // for every marker we've added previously, remove those that are no longer visible
      for (const id in markersOnScreen) {
        if (!newMarkers[id]) markersOnScreen[id].remove();
      }
      markersOnScreen = newMarkers;
    }

    // Add zoom and rotation controls to the map.
    map.addControl(new mapboxgl.NavigationControl());

    var loadHessLayers = this.loadHessLayers;
    var toggleMapLayer = this.toggleMapLayer;
    var zoomToSiteFromParams = this.zoomToSiteFromParams;
    var addDataLayer = this.addDataLayer;
    var openSiteEditModalMoreInfo = this.openSiteEditModalMoreInfo;
    var openSiteEditModal = this.openSiteEditModal;
  

    map.on("load", function (map) {
      //    Add Parcels Source
      map.target.addSource("parcelsSource", {
        type: "vector",
        url: "mapbox://mtc-basis.hess_public_core", //Parcel Atlas (updated September 20 2021)
      });
      //Add jurisdiction boundary source
      map.target.addSource("jurisdictionBoundarySource", {
        type: "geojson",
        data: placesGeoJSON,
      });
      
      map.target.addLayer({
        id: "parcels",
        type: "fill",
        source: "parcelsSource",
        minzoom: 15,
        maxzoom: 21,
        "source-layer": "hess_public_core",
        paint: {
          "fill-outline-color": "black",
          "fill-color": "white",
          "fill-opacity": 0.4,
        },
      });

      

      
      $scope.mapLayers.forEach(element => {
        if(element.name === 'countyLayer' || element.name === 'sphereofinfluenceLayer'){
          map.target.addSource(`${element.name}Source`, {
            type: 'geojson',
            // Use a URL for the value for the `data` property.
            data: element.url
            });

          map.target.addLayer(
            {
              id: element.name,
              type: "line",
              source: `${element.name}Source`,
              paint: element.paint,
              'layout': {
                // Make the layer visible by default.
                'visibility': 'none'
                }
            }
          );
        }
        
       });

      // When a click event occurs on a feature in the states layer, open a popup at the
      // location of the click, with description HTML from its properties.
      map.target.on("click", "parcels", function (e) {
        $('.mapboxgl-popup').remove();
        var coordinates = e.lngLat;
        // console.log("325: coordinates", coordinates);

        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        

        // set bbox as 5px reactangle area around clicked point
        var bbox = [
          [e.point.x - 5, e.point.y - 5],
          [e.point.x + 5, e.point.y + 5],
        ];
        var features = map.target.queryRenderedFeatures(bbox, {
          layers: ["parcels"],
        });
        // console.log(features);
        lookup.setParcelDetail(features[0].properties);
        features[0].properties.coordinates = coordinates;
        var info = features[0].properties;
        //Add popup
        new mapboxgl.Popup()
        .setLngLat(coordinates)
        .setHTML(`<h6>APN:</h6>${info.apn}<br><button id="moreInfoBtn" class="btn btn-primary">More Info</button>`)
        .addTo(map.target);
        //End popup

        var parcel_id = info.parcel_id;
        // console.log(parcel_id);

        // Get full parcel details 
        $http.get(`https://data.bayareametro.gov/resource/nsv6-h4ws.json?$where=parcel_id='${parcel_id}'`,)
              .then(response => {
                // console.log(response.data);
                $scope.hessParcel = response.data[0];
                //Create percentages and parse integers
                for (const key in $scope.hessParcel) {
                  $scope.affhPercent.forEach(fieldName => {
                    if (key === fieldName){
                      // console.log(key, ' ', fieldName);
                      $scope.hessParcel[key] = parseInt(100 * $scope.hessParcel[key]);
                      // console.log($scope.hessParcel[key]);
                    }
                  });
                
                }
                // console.log($scope.hessParcel);
              })
              .catch(err => {
                console.log(err);
              })

        // Load modal when clicking on more info button 
        $('#moreInfoBtn').on('click', function(){
             if (parcel_id) {
              $("#siteSelectionModal").modal();
           
            }
         });

        selectedRecords = $scope.selectedRecords;
        listRecords = $scope.listRecords;
        rowSelectedCollection = $scope.rowSelectedCollection;
        // updateInfoBox(e.features[0].properties.parcel_id, $http, $scope, dbFactory, coordinates, openSiteEditModalMoreInfo);

        var filter = features.reduce(
          function (memo, feature) {
            memo.push(feature.properties.parcel_id);

            var checkParcelId = feature.properties.parcel_id;
            var checkIndex = _.filter(selectedRecords,{parcel_id: feature.properties.parcel_id});
            var checkRemoveIndex = removeRecords.indexOf(checkParcelId);
            var checkAddIndex = addRecords.indexOf(checkParcelId);
            // var checkListIndex = listRecords.indexOf(checkParcelId);

            if (checkIndex.length > 0) {
              // Remove record from selected map layer
              // selectedRecords.splice(checkIndex, 1);
             
              // Remove record from selected tab table
              _.remove(selectedRecords, {
                parcel_id: feature.properties.parcel_id,
              });
            } else {
              selectedRecords.push(feature.properties);
            }

            // if (checkAddIndex > -1) {
            //   addRecords.splice(checkAddIndex, 1);
            // } else if (checkAddIndex === -1 && checkListIndex === -1) {
            //   addRecords.push(feature.properties.parcel_id);
            // }

            if (checkRemoveIndex > -1) {
              $scope.removeRecords.splice(checkRemoveIndex, 1);
            } 
            // console.log($scope.removeRecords);

            return memo;
          },
          ["in", "parcel_id"]
        );
        $scope.selectedRecords = selectedRecords;
        $scope.addSitesList = addSitesList;
        //Update Update button with selected records count

        var array1 = ["in", "parcel_id"];
        var array2 = _.map($scope.selectedRecords, 'parcel_id');;

        var array3 = array1.concat(array2);

        // Set the filter to populate features into the layer.
        // map.target.setFilter("parcels-highlighted", array3);
        map.target.selectedFilter = array3;

        $scope.selectedParcelId = e.features[0].properties.parcel_id;
        // updateInfoBox(
        //   e.features[0].properties.parcel_id,
        //   $http,
        //   $scope,
        //   dbFactory,
        //   openSiteEditModalMoreInfo
        // );
      });

      // Change the cursor to a pointer when the mouse is over the parcels layer.
      map.target.on("mouseenter", "parcels", function () {
        map.target.getCanvas().style.cursor = "pointer";
      });

      // Change it back to a pointer when it leaves.
      map.target.on("mouseleave", "parcels", function () {
        map.target.getCanvas().style.cursor = "";
      });



      // Add my sites
      map.target.addLayer({
        id: "ListLayer",
        type: "fill",
        source: "parcelsSource",
        minzoom: 12,
        maxzoom: 21,
        "source-layer": "hess_public_core",
        paint: {
          "fill-outline-color": "black",
          "fill-color": "#824086",
          "fill-opacity": 0.7,
        },
        filter: ["==", ["get", "in_cycle6"], true],
      });
     
      map.target.addLayer({
        id: "znLayer",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "hess_public_core",
        'paint': {
          'fill-color': {
            'property': 'zn_regional_description',
            'type':'categorical',
            'stops': [
              ['Agriculture','#00734c'],
              ['Commercial','#f71818'],
              ['Conservation and Ecology Areas','#3df4df'],
              ['Industrial','#7b33f7'],
              ['Mixed Use Commercial','#ed682a'],
              ['Mixed Use Residential','#b27e3a'],
              ['Multi-Family Residential','#f2b24b'],
              ['Parks and Open Space','#9de59c'],
              ['Public and Institutional','#187de2'],
              ['Single Family Residential','#f4e973'],
              ['Specific or Special Plan Areas','#afe8ea'],
              ['Transportation','#ceccd1'],
            ],
          'default':'#5e5e5e',
          },
          'fill-opacity': 0.5
        },
        'layout': {
          // Make the layer visible by default.
          'visibility': 'none'
          }
      }, 'ListLayer');
      
/**
 * Click events for approved sites
 */
      // When a click event occurs on a feature in the states layer, open a popup at the
      // location of the click, with description HTML from its properties.
      map.target.on("click", "ListLayer", function (e) {
        $('.mapboxgl-popup').remove(); 
        var coordinates = e.lngLat;
        // console.log("325: coordinates", coordinates);

        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        // set bbox as 5px reactangle area around clicked point
        var bbox = [
          [e.point.x - 5, e.point.y - 5],
          [e.point.x + 5, e.point.y + 5],
        ];
        var features = map.target.queryRenderedFeatures(bbox, {
          layers: ["ListLayer"],
        });
        console.log(features);
        features[0].properties.coordinates = coordinates;

        features[0].properties.coordinates = coordinates;
        var info = features[0].properties;
        var parcel_id = info.parcel_id;
        //Add popup
        new mapboxgl.Popup()
        .setLngLat(coordinates)
        .setHTML(`<h6>APN:</h6>${info.apn}<br><button id="moreInfoBtn" class="btn btn-primary">More Info</button>`)
        .addTo(map.target);
        //End popup

        $('#moreInfoBtn').on('click', function(){
           
          //Open CRUD Modal
          if (parcel_id) {
            $("#siteSelectionModal").modal();
            $http.get(`https://data.bayareametro.gov/resource/nsv6-h4ws.json?$where=parcel_id='${parcel_id}'`,)
            .then(response => {
              // console.log(response.data);
              $scope.hessParcel = response.data[0];
              //Create percentages and parse integers
              for (const key in $scope.hessParcel) {
                $scope.affhPercent.forEach(fieldName => {
                  if (key === fieldName){
                    // console.log(key, ' ', fieldName);
                    $scope.hessParcel[key] = parseInt(100 * $scope.hessParcel[key]);
                    // console.log($scope.hessParcel[key]);
                  }
                });
              
              }
              // console.log($scope.hessParcel);
            })
            .catch(err => {
              console.log(err);
            })
      
      
          }
      
    });

        selectedRecords = $scope.selectedRecords;
        listRecords = $scope.listRecords;
        rowSelectedCollection = $scope.rowSelectedCollection;
        // updateInfoBox(e.features[0].properties.parcel_id, $http, $scope, dbFactory, coordinates, openSiteEditModalMoreInfo);

        var filter = features.reduce(
          function (memo, feature) {
            memo.push(feature.properties.parcel_id);

            var checkParcelId = feature.properties.parcel_id;
            var checkIndex = _.filter(selectedRecords,{parcel_id: feature.properties.parcel_id});
            var checkRemoveIndex = removeRecords.indexOf(checkParcelId);
            var checkAddIndex = addRecords.indexOf(checkParcelId);
            // var checkListIndex = listRecords.indexOf(checkParcelId);

            if (checkIndex.length > 0) {
              // Remove record from selected map layer
              // selectedRecords.splice(checkIndex, 1);
             
              // Remove record from selected tab table
              _.remove(selectedRecords, {
                parcel_id: feature.properties.parcel_id,
              });
            } else {
              selectedRecords.push(feature.properties);
            }

            // if (checkAddIndex > -1) {
            //   addRecords.splice(checkAddIndex, 1);
            // } else if (checkAddIndex === -1 && checkListIndex === -1) {
            //   addRecords.push(feature.properties.parcel_id);
            // }

            if (checkRemoveIndex > -1) {
              $scope.removeRecords.splice(checkRemoveIndex, 1);
            } 
            // console.log($scope.removeRecords);

            return memo;
          },
          ["in", "parcel_id"]
        );
        $scope.selectedRecords = selectedRecords;
        $scope.addSitesList = addSitesList;
        //Update Update button with selected records count

        var array1 = ["in", "parcel_id"];
        var array2 = _.map($scope.selectedRecords, 'parcel_id');;

        var array3 = array1.concat(array2);

        // Set the filter to populate features into the layer.
        // map.target.setFilter("parcels-highlighted", array3);
        map.target.selectedFilter = array3;

        $scope.selectedParcelId = e.features[0].properties.parcel_id;
        // updateInfoBox(
        //   e.features[0].properties.parcel_id,
        //   $http,
        //   $scope,
        //   dbFactory,
        //   openSiteEditModalMoreInfo
        // );
      });

      // Change the cursor to a pointer when the mouse is over the parcels layer.
      map.target.on("mouseenter", "ListLayer", function () {
        map.target.getCanvas().style.cursor = "pointer";
      });

      // Change it back to a pointer when it leaves.
      map.target.on("mouseleave", "ListLayer", function () {
        map.target.getCanvas().style.cursor = "";
      });

/**
 * End click event for approved sites
 */
      //Jurisdiction Layer

      if (!map.target.getLayer("jurisdiction-boundary")) {
        map.target.addLayer({
          id: "jurisdiction-boundary",
          type: "line",
          source: "jurisdictionBoundarySource",
          paint: {
            "line-color": "black",
            "line-width": 2,
          },
          filter: ["in", "NAME", ""],
        });
      }

  
      // Map Layer Toggle
      var layerList = document.getElementById("menu");
      var inputs = layerList.getElementsByTagName("input");
      // console.log(inputs);

      //Add data layers once style has loaded
      map.target.on("style.load", function () {
        // Triggered when `setStyle` is called.
        // add data layers to map
        addDataLayer($http, $scope, mapService, map.target);
      });

      function switchLayer(layer) {
        // console.log(map);
        var layerId = layer.target.id;
        map.target.setStyle("mapbox://styles/mapbox/" + layerId);
      }

      for (var i = 0; i < inputs.length; i++) {
        inputs[i].onclick = switchLayer;
      }
      //End map layer toggle

      if ($scope.selectedJurisdiction !== "Region") {
        // console.log($scope.selectedJurisdiction);
        //Zoom map to jurisdiction currently logged in
        var zoomToFeature = _.filter(placesGeoJSON.features, function (item) {
          return item.properties.NAME === $scope.selectedJurisdiction;
        });
        // console.log(zoomToFeature);

        if (zoomToFeature[0]) {
          var bbox = turf.extent(zoomToFeature[0].geometry);
          map.target.fitBounds(bbox, {
            padding: -150,
          });
        }
      }

      map.target.on("click", "ListLayer", function (e) {
        // $('.mapboxgl-popup').remove();
        // updateInfoBox(
        //   e.features[0].properties.parcel_id,
        //   $http,
        //   $scope,
        //   dbFactory,
        //   openSiteEditModalMoreInfo
        // );
      });

      // Change the cursor to a pointer when the mouse is over the list layer.
      map.target.on("mouseenter", "ListLayer", function () {
        map.target.getCanvas().style.cursor = "pointer";
      });

      // Change it back to a pointer when it leaves.
      map.target.on("mouseleave", "ListLayer", function () {
        map.target.getCanvas().style.cursor = "";
      });


       //Hide loading bar once tiles from geojson are loaded
       map.target.on('data', function (e) {
        if(e.sourceId === 'parcelClusters'){
          // console.log(e);
        }
        if (e.dataType === 'source' && e.sourceId === 'parcelClusters' && !e.isSourceLoaded) {
            document.getElementById("loader").style.visibility = "visible";
        } else if(map.target.style.sourceCaches["parcelClusters"] && map.target.style.sourceCaches["parcelClusters"]._sourceLoaded){
          document.getElementById("loader").style.visibility = "hidden";
        }
    })
    

      /**
       * Clustering samples
       */
      // Add a new source from our GeoJSON data and
      // set the 'cluster' option to true. GL-JS will
      // add the point_count property to your source data.
      map.target.addSource(`parcelClusters`, {
        type: "geojson",
        // Point to GeoJSON data. This example visualizes all M1.0+ parcelClusters
        // from 12/22/15 to 1/21/16 as logged by USGS' Earthquake hazards program.
        data: 'https://data.bayareametro.gov/resource/i3y7-84ng.geojson?$limit=100000',
        cluster: true,
        clusterMaxZoom: 16, // Max zoom to cluster points on
        clusterRadius: 50, // Radius of each cluster when clustering points (defaults to 50)
        tolerance: 0.5,
        buffer: 0,
        maxzoom: 18
      });

      
      map.target.addLayer({
        id: `clusters`,
        type: "circle",
        source: `parcelClusters`,
        minzoom: 8,
        maxzoom: 12,
        filter: ["has", "point_count"],
        paint: {
          // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
          // with three steps to implement three types of circles:
          //   * Blue, 20px circles when point count is less than 100
          //   * Yellow, 30px circles when point count is between 100 and 750
          //   * Pink, 40px circles when point count is greater than or equal to 750
          "circle-color": [
            "step",
            ["get", "point_count"],
            "#800080",
            1000,
            "#800080",
            10000,
            "#800080",
          ],
          "circle-radius": [
            "step",
            ["get", "point_count"],
            20,
            100,
            30,
            2000,
            40,
          ],
          "circle-opacity": 0.6,
          "circle-stroke-color": "#ffffff",
          "circle-stroke-width": 2,
        },
      });

      map.target.addLayer({
        id: `cluster-count`,
        type: "symbol",
        source: `parcelClusters`,
        minzoom: 8,
        maxzoom: 12,
        filter: ["has", "point_count"],
        layout: {
          "text-field": ["get", "point_count_abbreviated"],
          "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
          "text-size": 12,
        },
        paint: {
          "text-color": "#ffffff",
        },
      });

      map.target.addLayer({
        id: `unclustered-point`,
        type: "circle",
        source: `parcelClusters`,
        minzoom: 8,
        maxzoom: 12,
        filter: ["!", ["has", "point_count"]],
        paint: {
          "circle-color": "#800080",
          "circle-radius": 4,
          "circle-stroke-width": 1,
          "circle-stroke-color": "#fff",
        },
      });

            // inspect a cluster on click
    map.target.on('click', `clusters`, (e) => {
      const features = map.target.queryRenderedFeatures(e.point, {
      layers: [`clusters`]
      });
      const clusterId = features[0].properties.cluster_id;
      map.target.getSource(`parcelClusters`).getClusterExpansionZoom(
      clusterId,
      (err, zoom) => {
      if (err) return;

      
    // When a click event occurs on a feature in
    // the unclustered-point layer, open a popup at
    // the location of the feature, with
    // description HTML from its properties.
    map.target.on('click', `unclustered-point`, (e) => {
      const coordinates = e.features[0].geometry.coordinates.slice();
      // console.log(e.features[0]);
      const mag = e.features[0].properties.jurisdiction;
      const tsunami =
      e.features[0].properties.in_cycle6 === "1.0" ? 'yes' : 'no';

      // Ensure that if the map is zoomed out such that
      // multiple copies of the feature are visible, the
      // popup appears over the copy being pointed to.
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }

      new mapboxgl.Popup()
      .setLngLat(coordinates)
      .setHTML(
      `Jurisdiction: ${mag}<br>Certified Site?: ${tsunami}`
      )
      .addTo(map.target);
      });

      map.target.on('mouseenter', `clusters`, () => {
      map.target.getCanvas().style.cursor = 'pointer';
      });
      map.target.on('mouseleave', `clusters`, () => {
      map.target.getCanvas().style.cursor = '';
      });

    });


    map.target.easeTo({
    center: features[0].geometry.coordinates,
    zoom: zoom
    });
    }
    );

    
      

      /**
       * End Clustering sample
       */

   

      // Set global map variable based on local map variable settings
      $scope.map = map.target;
     

    

      // Zoom to site if parameters present for parcel id
      zoomToSiteFromParams($scope.dataParcel_id, $scope, $http, $location);
    });

    this.$scope.map = map;
 
    //Load zoning, gp and existing use codes
    this.loadAllCodes();

    this.loadJurisdictions();

    // Zoom to site if parameters present for parcel id
    zoomToSiteFromParams($scope.dataParcel_id, $scope, $http, $location);

    // this.$scope.mapLoading = false;
  }

  updateGeography(geo, type) {
    // console.log(geo);
    // console.log(type)
    var $scope = this.$scope;
    var loadMap = this.loadMap;
    // console.log($scope);

    if (type === "jurisdiction") {
      // console.log(geo);
      //Zoom map to geodiction currently logged in
      var zoomToFeature = _.filter(placesGeoJSON.features, function (item) {
        return item.properties.NAME === geo;
      });
      // console.log(zoomToFeature);

      var bbox = turf.extent(zoomToFeature[0].geometry);
      $scope.map.fitBounds(bbox, {
        padding: -150,
      });
    } else if (type === "county") {
      this.$http
        .get(
          `https://data.bayareametro.gov/resource/t75i-n3yr.geojson?$select=the_geom&$where=name=%27${geo}%27`
        )
        .then((response) => {
          // console.log(response);
          var bbox = turf.extent(response.data.features[0].geometry);
          $scope.map.fitBounds(bbox, {
            padding: -150,
          });
        });
      // console.log(geo);
      //Zoom map to geodiction currently logged in
      var zoomToFeature = _.filter(placesGeoJSON.features, function (item) {
        return item.properties.NAME === geo;
      });
      // console.log(zoomToFeature);
    } else if (type === "region") {
      $scope.map.setZoom(9);
      $scope.map.setCenter([-122.275051, 37.796966]);
    }

    this.clearSelected();
  }

  /**
   * @desc Opens appropriate update modal window based on parameters
   * @param {object} data - data loaded from value selected in the table
   * @param (string) crudType - type of update operation to perform (values: create, edit or delete)
   */
  zoomToSiteFromParams(parcelId, $scope, $http, $location) {
    //Open CRUD Modal
    //    $scope.zoomSpinner = true;
    if (parcelId) {
      $http
        .get("https://api.mtcanalytics.org/api/socrata/parcel/geo/" + parcelId)
        .then((response) => {
          if ($scope.map.getSource("zoomParcelSource")) {
            $scope.map.removeLayer("zoomParcelLayer");
            $scope.map.removeSource("zoomParcelSource");
          }
          
          var bbox = turf.extent(response.data[0].geometry);
          $scope.map.fitBounds(bbox, {
            padding: -50,
          });
          $scope.zoomSpinner = false;
        })
        .catch((err) => {
          console.log(err);
        });
      // Resize map after modal div is fully rendered
      $location.search({});
    }
  }


  loadJurisdictions(county) {
    // console.log(county);
    if (county === "Region") {
      this.$scope.jurisdictionList = [];
      // console.log(this.$scope.jurisdictionList);
      this.$scope.filter.jurisdiction = "";
      // console.log(this.$scope.filter);
      this.loadMap("Region");
    } else {
      this.$http
        .get(
          `https://data.bayareametro.gov/resource/v6h3-e68p.json?basis_county='${county}'`
        )
        .then((response) => {
          this.$scope.jurisdictionList = response.data;
          // console.log(this.$scope.jurisdictionList);
          this.$scope.selectedJurisdiction = "";
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  loadCountyList() {
    // console.log("running...");
    this.$http
      .get(
        "https://data.bayareametro.gov/resource/v6h3-e68p.json?$select=basis_county&$group=basis_county&$order=basis_county"
      )
      .then((response) => {
        // console.log(response.data);
        this.$scope.countyList = response.data;
        
      })
      .catch((err) => {
        console.log(err);
      });
  }


  loadAllCodes() {
    this.$scope.zn_codes = [];
    this.$scope.gp_codes = [];
    this.$scope.use_codes = [];
    //Get list of zoning codes. If list doesn't exist in lookup service, request from server
    // if (this.lookup.getZoningCodes().length > 0) {
    //   this.$scope.zn_codes = this.lookup.getZoningCodes();
    // } else {
    this.$http
      .get('/assets/js/data/zn_codes_by_jurisdiction.json')
      .then((response) => {
        // console.log("zoning codes: ", response.data);
        this.$scope.zn_codes = response.data;
        //Set zoning codes in lookup service
        this.lookup.setZoningCodes(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
    // }

    //Get list of GP codes. If list doesn't exist in lookup service, request from server
    // if (this.lookup.getGPCodes().length > 0) {
    //   this.$scope.gp_codes = this.lookup.getGPCodes();
    // } else {
    this.$http
      .get('/assets/js/data/gp_codes_by_jurisdiction.json')
      .then((response) => {
        this.$scope.gp_codes = response.data;
        // console.log("gp_codes: ", this.$scope.gp_codes);
        //Set GP codes in lookup service
        this.lookup.setGPCodes(response.data);
      })
      .catch((err) => {
        console.log(err);
      });

  }

  updateCodes(){
    var jurisdiction = this.$scope.filter.jurisdiction;
    // console.log(jurisdiction);
    
    this.$scope.zn_codes =  _.filter(this.lookup.getZoningCodes(),function(o){
      return o.jurisdiction === jurisdiction && o.zn_code
    });
    // console.log(this.$scope.zn_codes, " zonning codes");
    
    this.$scope.gp_codes =  _.filter(this.lookup.getGPCodes(),function(o){
      return o.jurisdiction === jurisdiction && o.gp_code
    });
  
}

turnOffAllLayers(){
  for (let index = 0; index < this.$scope.mapLayers.length; index++) {
    const element = this.$scope.mapLayers[index];
    if (this.$scope.map.getSource(element.source)) {
      this.$scope.map.setLayoutProperty(element.name, "visibility", "none");
      this.$scope[element.name + "Toggle"] = false;
      this.$scope.loadingDiv = false;
    }
    this.$scope.loadingDiv = true;
  }

}


  toggleMapLayer(layerName) {
    var visibility;
    this.$scope.loadingDiv = true;
    var type;

    if(layerName === 'znLayer'){
      visibility = this.$scope.map.getLayoutProperty(
        'znLayer',
        "visibility"
      );
      console.log(visibility);

        // toggle layer visibility by changing the layout object's visibility property
        if (visibility === "visible") {
          this.$scope.map.setLayoutProperty(
            'znLayer',
            "visibility",
            "none"
          );
          this.$scope.visibleLayer = 'znLayer';
          this.className = "";
        } else {
          this.className = "active";
          this.$scope.map.setLayoutProperty(
            'znLayer',
            "visibility",
            "visible"
          );
        }

     } else {
      this.$scope.map.setLayoutProperty(
        'znLayer',
        "visibility",
        "none"
      );
      this.$scope.znLayerToggle = false;
     }

    for (let index = 0; index < this.$scope.mapLayers.length; index++) {
      const element = this.$scope.mapLayers[index];
    
    // For the case of generalized regional zoning 
  
    //  For all other layers 
      if (element.name === layerName) {
         this.$scope.map.layerName = element.name;
        // console.log(element.name);
        // console.log(layerName);
        if (this.$scope.map.getSource(element.source)) {
          visibility = this.$scope.map.getLayoutProperty(
            element.name,
            "visibility"
          );
          // toggle layer visibility by changing the layout object's visibility property
          if (visibility === "visible") {
            this.$scope.map.setLayoutProperty(
              element.name,
              "visibility",
              "none"
            );
            this.$scope.visibleLayer = element.name;
            this.className = "";
          } else {
            this.className = "active";
            this.$scope.map.setLayoutProperty(
              element.name,
              "visibility",
              "visible"
            );
          }
          this.$scope.loadingDiv = false;
        } else {
          // console.log(element.url);
          this.$http
            .get(element.url)
            .then((response) => {
              console.log(response.data);
              var layerData = response.data;
              // console.log(layerData);
              var paint = {};
              if (element.type === "mapbox") {
                // paint = {
                //   "fill-outline-color": "white",
                //   "fill-color": element.fillColor,
                //   "fill-opacity": 0.4,
                // };

                this.$scope.map.addSource(element.source, {
                  type: layerData.sources.composite.type,
                  url: layerData.sources.composite.url, //Parcel Atlas (updated September 15 2021)
                });
              } else if (element.type === "socrata") {
                if (
                  element.style === "numerical" ||
                  element.style === "circle"
                ) {
                  // console.log(element.property);
                  layerData.features.forEach((data) => {
                    data.properties[element.property] = parseFloat(
                      data.properties[element.property]
                    );
                  });
                  console.log(layerData);
                  paint = element.paint;
                  this.$scope.map.addSource(element.source, {
                    type: "geojson",
                    data: layerData,
                  });
                } else if (
                  element.style === "line" ||
                  element.style === "fill"
                ) {
                  paint = element.paint;
                  console.log(paint);
                  this.$scope.map.addSource(element.source, {
                    type: "geojson",
                    data: element.url,
                  });
                }
              }

              //Add filter for jurisdiction
              if (element.type === "mapbox") {
                if (layerData.layers[0].filter) {
                  // console.log(layerData.layers[0].filter);
                  this.$scope.map.addLayer({
                    id: element.name,
                    type: layerData.layers[0].type,
                    source: element.source,
                    "source-layer": layerData.layers[0]["source-layer"],
                    paint: layerData.layers[0].paint,
                    filter: layerData.layers[0].filter,
                  },'parcels');
                } else {
                  this.$scope.map.addLayer({
                    id: element.name,
                    type: layerData.layers[0].type,
                    source: element.source,
                    "source-layer": layerData.layers[0]["source-layer"],
                    paint: layerData.layers[0].paint,
                  },'parcels');
                }
              } else if (element.type === "socrata") {
                if (element.style === "circle") {
                  type = "circle";
                } else if (element.style === "line") {
                  type = "line";
                } else {
                  type = "fill";
                }
                this.$scope.map.addLayer(
                  {
                    id: element.name,
                    type: type,
                    source: element.source,
                    paint: element.paint,
                  },
                  "parcels"
                );
                //  console.log(element.paint);
                // this.$scope.map.addLayer({
                //   id: element.name,
                //   type: 'fill',
                //   source: element.source,
                //   'paint': {
                //     'fill-color': {
                //         property: 'hcv_pct',
                //         stops: [
                //             [0.2, 'lightgray'],
                //             [0.5, 'red'],
                //             [15.0, 'blue']
                //         ]
                //     }

                // });
              }

              this.$scope.map.setLayoutProperty(
                element.name,
                "visibility",
                "visible"
              );

              // Add default opacity to 50%
              if (
                element.name !== "sphereofinfluenceLayer" &&
                element.type === "socrata"
              ) {
                this.$scope.map.setPaintProperty(
                  element.name,
                  "fill-opacity",
                  0.5
                );
              }

              // Filter zoning and gp layers to only show data in jurisdiction
              if (element.name === "znLayer" || element.name === "gpLayer") {
                this.$scope.map.setFilter(element.name, [
                  "in",
                  "jurisdiction",
                  this.$scope.filter.jurisdiction,
                ]);
              }

              if (element.name === "sphereofinfluenceLayer") {
                // console.log(element.name);
                this.$scope.map.setFilter(element.name, [
                  "match",
                  ["get", "jurname"],
                  [this.$scope.filter.jurisdiction],
                  true,
                  false,
                ]);
              }

              if (element.name === "countyLayer") {
                // console.log(element.name);
                if(this.$scope.filter.pa_county && this.$scope.filter.pa_county === 'Region'){
                  this.$scope.map.setFilter(element.name, null);
                } else {
                  this.$scope.map.setFilter(element.name, [
                    "match",
                    ["get", "name"],
                    [`${this.$scope.filter.pa_county} County`],
                    true,
                    false,
                  ]);
                }
              }

              this.$scope.loadingDiv = false;
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else {
        if (this.$scope.map.getSource(element.source)) {
          this.$scope.map.setLayoutProperty(element.name, "visibility", "none");
          this.$scope[element.name + "Toggle"] = false;
          this.$scope.loadingDiv = false;
        }
      }
      this.$scope.loadingDiv = true;
    }

 

    //My list Layer
    if (layerName === "ListLayer") {
      // visibility = this.$scope.map.getLayoutProperty(layerName, 'visibility');
      // console.log("the visibility: ", visibility);
      // toggle layer visibility by changing the layout object's visibility property
      if (this.$scope.listToggle) {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "none");
      } else {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "visible");
      }
      this.$scope.loadingDiv = false;
    }


  }

  toggleBoundaryLayer(layerName){
    console.log(layerName);
    var visibility;
    this.$scope.loadingDiv = true;
    var type;

    var boundaryList = [{
      'source': 'countyLayerSource',
      'type': 'socrata',
      'name': 'countyLayer',
      'url': 'https://data.bayareametro.gov/resource/t75i-n3yr.geojson',
      'style':'line',
      'paint': {
        'line-color': 'rgba(0, 0, 0, 0.8)',
      'line-width': 2
        }
    },{
      'source': 'sphereofinfluenceLayerSource',
      'type': 'socrata',
      'name': 'sphereofinfluenceLayer',
      'url': 'https://data.bayareametro.gov/resource/t4cz-2jap.geojson',
      'style':'line',
      'paint': {
        'line-color': 'rgba(0, 0, 0, 0.8)',
      'line-width': 2
        }
    }]


    for (let index = 0; index < boundaryList.length; index++) {
      const element = boundaryList[index];
     
      if (element.name === layerName) {
         this.$scope.map.layerName = element.name;
        // console.log(element.name);
        // console.log(layerName);
        if (this.$scope.map.getSource(element.source)) {
          visibility = this.$scope.map.getLayoutProperty(
            element.name,
            "visibility"
          );
          // toggle layer visibility by changing the layout object's visibility property
          if (visibility === "visible") {
            this.$scope.map.setLayoutProperty(
              element.name,
              "visibility",
              "none"
            );
            this.$scope.visibleLayer = element.name;
            this.className = "";
          } else {
            this.className = "active";
            this.$scope.map.setLayoutProperty(
              element.name,
              "visibility",
              "visible"
            );
          }
          this.$scope.loadingDiv = false;
        } else {
          // console.log(element.url);
          this.$http
            .get(element.url)
            .then((response) => {
              // console.log(response.data);
              var layerData = response.data;
              // console.log(layerData);
              var paint = {};
              if (element.type === "mapbox") {
                // paint = {
                //   "fill-outline-color": "white",
                //   "fill-color": element.fillColor,
                //   "fill-opacity": 0.4,
                // };

                this.$scope.map.addSource(element.source, {
                  type: layerData.sources.composite.type,
                  url: layerData.sources.composite.url, //Parcel Atlas (updated September 15 2021)
                });
              } else if (element.type === "socrata") {
                if (
                  element.style === "numerical" ||
                  element.style === "circle"
                ) {
                  // console.log(element.property);
                  layerData.features.forEach((data) => {
                    data.properties[element.property] = parseFloat(
                      data.properties[element.property]
                    );
                  });

                  paint = element.paint;
                  this.$scope.map.addSource(element.source, {
                    type: "geojson",
                    data: layerData,
                  });
                } else if (
                  element.style === "line" ||
                  element.style === "fill"
                ) {
                  paint = element.paint;
                  // console.log(paint);
                  this.$scope.map.addSource(element.source, {
                    type: "geojson",
                    data: element.url,
                  });
                }
              }

              //Add filter for jurisdiction
              if (element.type === "mapbox") {
                if (layerData.layers[0].filter) {
                  // console.log(layerData.layers[0].filter);
                  this.$scope.map.addLayer({
                    id: element.name,
                    type: layerData.layers[0].type,
                    source: element.source,
                    "source-layer": layerData.layers[0]["source-layer"],
                    paint: layerData.layers[0].paint,
                    filter: layerData.layers[0].filter,
                  },'parcels');
                } else {
                  this.$scope.map.addLayer({
                    id: element.name,
                    type: layerData.layers[0].type,
                    source: element.source,
                    "source-layer": layerData.layers[0]["source-layer"],
                    paint: layerData.layers[0].paint,
                  },'parcels');
                }
              } else if (element.type === "socrata") {
                if (element.style === "circle") {
                  type = "circle";
                } else if (element.style === "line") {
                  type = "line";
                } else {
                  type = "fill";
                }
                this.$scope.map.addLayer(
                  {
                    id: element.name,
                    type: type,
                    source: element.source,
                    paint: element.paint,
                  },
                  "parcels"
                );
                //  console.log(element.paint);
                // this.$scope.map.addLayer({
                //   id: element.name,
                //   type: 'fill',
                //   source: element.source,
                //   'paint': {
                //     'fill-color': {
                //         property: 'hcv_pct',
                //         stops: [
                //             [0.2, 'lightgray'],
                //             [0.5, 'red'],
                //             [15.0, 'blue']
                //         ]
                //     }

                // });
              }

              this.$scope.map.setLayoutProperty(
                element.name,
                "visibility",
                "visible"
              );

              // Add default opacity to 50%
              if (
                element.name !== "sphereofinfluenceLayer" &&
                element.type === "socrata"
              ) {
                this.$scope.map.setPaintProperty(
                  element.name,
                  "fill-opacity",
                  0.5
                );
              }

              // Filter zoning and gp layers to only show data in jurisdiction
              if (element.name === "znLayer" || element.name === "gpLayer") {
                this.$scope.map.setFilter(element.name, [
                  "in",
                  "jurisdiction",
                  this.$scope.filter.jurisdiction,
                ]);
              }

              if (element.name === "sphereofinfluenceLayer") {
                // console.log(element.name);
                this.$scope.map.setFilter(element.name, [
                  "match",
                  ["get", "jurname"],
                  [this.$scope.filter.jurisdiction],
                  true,
                  false,
                ]);
              }

              if (element.name === "countyLayer") {
                // console.log(element.name);
                if(this.$scope.filter.pa_county && this.$scope.filter.pa_county === 'Region'){
                  this.$scope.map.setFilter(element.name, null);
                } else {
                  this.$scope.map.setFilter(element.name, [
                    "match",
                    ["get", "name"],
                    [`${this.$scope.filter.pa_county} County`],
                    true,
                    false,
                  ]);
                }
              }

              this.$scope.loadingDiv = false;
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else {
        if (this.$scope.map.getSource(element.source)) {
          this.$scope.map.setLayoutProperty(element.name, "visibility", "none");
          this.$scope[element.name + "Toggle"] = false;
          this.$scope.loadingDiv = false;
        }
      }
      this.$scope.loadingDiv = false;
    }
   this.$scope.loadingDiv = false;
  }


  toggleAFFHMapLayer(layerName) {
    var visibility;
    this.$scope.loadingDiv = true;
    var type;
    // console.log(layerName);
    this.$scope.layerLegend = [];
    var legend;

    // //My list Layer
    if (layerName === "ListLayer") {
      // console.log("the visibility: ", visibility);
      if (this.$scope.listToggle) {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "none");
      } else {
        this.$scope.map.setLayoutProperty(layerName, "visibility", "visible");
      }
      this.$scope.loadingDiv = false;
    } else {
      for (let index = 0; index < this.$scope.mapLayers.length; index++) {
        const element = this.$scope.mapLayers[index];

        if (element.name === layerName) {
          // Check if source already exists in map
          this.$scope.map.layerName = element.name;

          if (this.$scope.map.getSource(element.source)) {
            // console.log("source exists");

            visibility = this.$scope.map.getLayoutProperty(
              element.name,
              "visibility"
            );
            // console.log("the visibility", visibility);
            // Toggle layer visibility by changing the layout object's visibility property
            if (visibility === "visible") {
              this.$scope.map.setLayoutProperty(
                element.name,
                "visibility",
                "none"
              );
              this.$scope.visibleLayer = element.name;
              this.className = "";
            } else {
              this.className = "active";
              this.$scope.map.setLayoutProperty(
                element.name,
                "visibility",
                "visible"
              );
            }
            //Add dynamic legend based on circle, numerical or categorical styles
            // console.log("Legend: ", element.paint);
            if (element.style === "circle") {
              legend = element.paint;
              legend["circle-radius"].stops.forEach((circleItem) => {
                this.$scope.layerLegend.push({
                  type: "circle",
                  color: legend["circle-color"],
                  value: circleItem[0] + " units",
                  size: circleItem[1] + "px",
                });
              });
            } else {
              if (element.paint["fill-color"].stops) {
                legend = element.paint["fill-color"].stops;
                // console.log(element.paint);
                legend.forEach((legend) => {
                  if (element.style === "numerical") {
                    this.$scope.layerLegend.push({
                      type: "numerical",
                      value: legend[0] + "%",
                      color: legend[1],
                    });
                  } else if (element.style === "categorical") {
                    this.$scope.layerLegend.push({
                      type: "categorical",
                      value: legend[0],
                      color: legend[1],
                    });
                  } else if (element.name === "recapLayer") {
                  } else if (element.name === "rcaaLayer") {
                  }
                });
              }
              // console.log(this.$scope.layerLegend);
            }
            // End legend

            this.$scope.loadingDiv = false;
          } else {
            //If the source doesn't already exist on the map, add it via the API
            // console.log("source doesnt exist");
            // console.log(element.url);

            //Get data from Socrata/Mapbox and add it to layerData
            this.$http
              .get(element.url)
              .then((response) => {
                var layerData = response.data;
                // console.log(layerData);
                var paint = {};

                //Style mapbox layers
                if (element.type === "mapbox") {
                  this.$scope.map.addSource(element.source, {
                    type: layerData.sources.composite.type,
                    url: layerData.sources.composite.url, //Parcel Atlas (updated September 15 2021)
                  });

                  // Check if a filter exists on mapbox and/or add it to the layer
                  if (layerData.layers[0].filter) {
                    // console.log(layerData.layers[0].filter);
                    this.$scope.map.addLayer(
                      {
                        id: element.name,
                        type: layerData.layers[0].type,
                        source: element.source,
                        "source-layer": layerData.layers[0]["source-layer"],
                        paint: layerData.layers[0].paint,
                        filter: layerData.layers[0].filter,
                      },
                      "ListLayer"
                    );
                  } else {
                    this.$scope.map.addLayer(
                      {
                        id: element.name,
                        type: layerData.layers[0].type,
                        source: element.source,
                        "source-layer": layerData.layers[0]["source-layer"],
                        paint: layerData.layers[0].paint,
                      },
                      "ListLayer"
                    );
                  }
                }

                //  Style socrata tract layers
                else if (element.type === "socrata") {
                  //Set the paint type based on the style from map.service.js
                  if (element.style === "circle") {
                    type = "circle";
                  } else {
                    type = "fill";
                  }

                  //For numerical styles, make sure values are numbers and not strings
                  if (element.style !== "circle") {
                    // console.log(element.property);
                    // console.log(layerData);
                    if (element.style === "numerical") {
                      layerData.forEach((data) => {
                        data[element.property] = parseFloat(
                          data[element.property]
                        );
                      });
                    }

                    if (element.name === "raceEthnicityLayer") {
                      //Retrieve Block Geometry Layer
                      this.$http
                        .get(
                          "https://data.bayareametro.gov/resource/f86g-vq5u.geojson?$limit=5000000"
                        )
                        .then((response) => {
                          // console.log(response.data);

                          var blockGeo = response.data;

                          // Numerical or Categorical styles -- Join layerData attributes to tract geometry
                          if (element.style === "numerical") {
                            blockGeo.features.forEach((block_element) => {
                              var blockId = _.filter(layerData, {
                                blkgp_geoid: block_element.properties.geoid,
                              });
                              if (blockId[0]) {
                                block_element.properties[element.property] =
                                  parseFloat(blockId[0][element.property]);
                              }
                            });
                          } else if (element.style === "categorical") {
                            blockGeo.features.forEach((block_element) => {
                              var blockId = _.filter(layerData, {
                                blkgp_geoid: block_element.properties.geoid,
                              });
                              if (blockId[0]) {
                                block_element.properties[element.property] =
                                  blockId[0][element.property];
                              }
                            });
                          }

                          // console.log(element.source);
                          // console.log(blockGeo);

                          //  Add source and layer to the map
                          this.$scope.map.addSource(element.source, {
                            type: "geojson",
                            data: blockGeo,
                          });

                          this.$scope.map.addLayer(
                            {
                              id: element.name,
                              type: type,
                              source: element.source,
                              paint: element.paint,
                            },
                            "ListLayer"
                          );

                          //Add dynamic legend
                          // console.log("Legend: ", element.paint);
                          legend = element.paint["fill-color"].stops;
                          // console.log(element.paint);
                          legend.forEach((legend) => {
                            if (element.style === "numerical") {
                              this.$scope.layerLegend.push({
                                type: "numerical",
                                value: legend[0] + "%",
                                color: legend[1],
                              });
                            } else {
                              this.$scope.layerLegend.push({
                                type: "categorical",
                                value: legend[0],
                                color: legend[1],
                              });
                            }
                          });
                          // console.log(this.$scope.layerLegend);

                          this.$scope.map.setLayoutProperty(
                            element.name,
                            "visibility",
                            "visible"
                          );
                        });
                    } else if (layerName === "hcdaffhtcacLayer") {
                      // console.log(layerData);
                      this.$scope.map.addSource(element.source, {
                        type: "geojson",
                        data: layerData,
                      });

                      this.$scope.map.addLayer(
                        {
                          id: element.name,
                          type: type,
                          source: element.source,
                          paint: element.paint,
                        },
                        "ListLayer"
                      );
                      this.$scope.map.setLayoutProperty(
                        element.name,
                        "visibility",
                        "visible"
                      );
                      // console.log(this.$scope.hcdaffhtcacLayerToggle);

                      legend = element.paint["fill-color"].stops;
                      // console.log(element.paint);
                      legend.forEach((legend) => {
                        this.$scope.layerLegend.push({
                          type: "categorical",
                          value: legend[0],
                          color: legend[1],
                        });
                      });
                    } else {
                      // Retrieve Tract Geometry layer
                      this.$http
                        .get(
                          "https://data.bayareametro.gov/resource/j4u9-t2hp.geojson?$limit=20000"
                        )
                        .then((response) => {
                          // console.log(response.data);

                          var tractGeo = response.data;

                          // Numerical or Categorical styles -- Join layerData attributes to tract geometry
                          if (element.style === "numerical") {
                            tractGeo.features.forEach((tract_element) => {
                              var tractId = _.filter(layerData, {
                                tract_geoid: tract_element.properties.geoid,
                              });
                              if (tractId[0]) {
                                // console.log(tractId[0]);
                                tract_element.properties[element.property] =
                                  parseFloat(tractId[0][element.property]);
                              }
                            });
                          } else if (element.style === "categorical") {
                            // console.log(layerData);

                            tractGeo.features.forEach((tract_element) => {
                              var tractId = _.filter(layerData, {
                                tract_geoid: tract_element.properties.geoid,
                              });
                              // console.log(tractId);
                              if (tractId[0]) {
                                tract_element.properties[element.property] =
                                  tractId[0][element.property];
                              }
                            });
                          } else if (element.style === "single") {
                            // console.log("single");
                            tractGeo.features = _.filter(
                              tractGeo.features,
                              function (geo) {
                                // console.log(geo);
                                var test = _.filter(layerData, {
                                  tract_geoid: geo.properties.geoid,
                                });
                                if (test[0]) {
                                  return geo;
                                }
                              }
                            );
                            // tractGeo.features = features;
                          }
                          // console.log(element.name);
                          // console.log(element.source);
                          // console.log(tractGeo);

                          //  Add source and layer to the map
                          this.$scope.map.addSource(element.source, {
                            type: "geojson",
                            data: tractGeo,
                          });

                          this.$scope.map.addLayer(
                            {
                              id: element.name,
                              type: type,
                              source: element.source,
                              paint: element.paint,
                            },
                            "ListLayer"
                          );

                          //Add dynamic legend
                          // console.log("Legend: ", element.paint);
                          if (element.paint["fill-color"].stops) {
                            legend = element.paint["fill-color"].stops;
                            // console.log(element.paint);
                            legend.forEach((legend) => {
                              if (element.style === "numerical") {
                                if (layerName === "householdIncomeLayer") {
                                  this.$scope.layerLegend.push({
                                    type: "numerical",
                                    value: "$" + legend[0],
                                    color: legend[1],
                                  });
                                } else {
                                  this.$scope.layerLegend.push({
                                    type: "numerical",
                                    value: legend[0] + "%",
                                    color: legend[1],
                                  });
                                }
                              } else {
                                this.$scope.layerLegend.push({
                                  type: "categorical",
                                  value: legend[0],
                                  color: legend[1],
                                });
                              }
                            });
                          }
                          // console.log(this.$scope.layerLegend);

                          this.$scope.map.setLayoutProperty(
                            element.name,
                            "visibility",
                            "visible"
                          );
                        });
                    }
                  }

                  // Circle/point styles -- Join layer attributes to tract geometry
                  if (element.style === "circle") {
                    // console.log(element.property);
                    // console.log(layerData);
                    layerData.features.forEach((data) => {
                      data.properties[element.property] = parseFloat(
                        data.properties[element.property]
                      );
                    });

                    this.$scope.map.addSource(element.source, {
                      type: "geojson",
                      data: layerData,
                    });
                    // console.log(element.paint);

                    // Add dynamic legend
                    legend = element.paint;
                    legend["circle-radius"].stops.forEach((circleItem) => {
                      this.$scope.layerLegend.push({
                        type: "circle",
                        color: legend["circle-color"],
                        value: circleItem[0] + " units",
                        size: circleItem[1] + "px",
                      });
                    });

                    this.$scope.map.addLayer({
                      id: element.name,
                      type: type,
                      source: element.source,
                      paint: element.paint,
                    });
                  }
                }

                // Add default opacity to 50%
                if (
                  element.name !== "sphereofinfluenceLayer" &&
                  element.type === "socrata"
                ) {
                  this.$scope.map.setPaintProperty(
                    element.name,
                    "fill-opacity",
                    0.5
                  );
                }

                if (element.name === "sphereofinfluenceLayer") {
                  // console.log(element.name);
                  this.$scope.map.setFilter(element.name, [
                    "match",
                    ["get", "jurname"],
                    [this.$scope.filter.jurisdiction],
                    true,
                    false,
                  ]);
                }

                if (element.name === "countyLayer") {
                  // console.log(element.name);
                  this.$scope.map.setFilter(element.name, [
                    "match",
                    ["get", "name"],
                    [`${this.$scope.filter.pa_county} County`],
                    true,
                    false,
                  ]);
                }

                this.$scope.loadingDiv = false;
              })
              .catch((err) => {
                console.log(err);
              });
          }
        } else {
          if (this.$scope.map.getSource(element.source)) {
            this.$scope.map.setLayoutProperty(
              element.name,
              "visibility",
              "none"
            );
            this.$scope[element.name + "Toggle"] = false;
            this.$scope.loadingDiv = false;
          }
        }

        this.$scope.loadingDiv = true;
      }
    }
  }


  updateFilterLength() {
    //Update zoning and gp codes
    this.updateCodes();
    console.log(this.$scope.filter);
    if(this.$scope.filter.pa_county && this.$scope.filter.pa_county === 'Region'){
      delete this.$scope.filter.pa_county;
    }
     // Remove any false values from filter
     for (const key in this.$scope.filter) {
      if (this.$scope.filter.hasOwnProperty(key)) {
        if (this.$scope.filter[key] === false || this.$scope.filter[key] == null || this.$scope.filter[key] === 'null') {
          delete this.$scope.filter[key];
        }
      }
    }
    //County and jurisdiction
    if (this.$scope.filter.pa_county && this.$scope.filter.pa_county !== 'Region') {
      this.$scope.showMoreFilters = true;
      this.loadJurisdictions(this.$scope.filter.pa_county);

      this.$scope.map.setFilter("countyLayer", [
        "match",
        ["get", "name"],
        [`${this.$scope.filter.pa_county} County`],
        true,
        false,
      ]);
    } else if(this.$scope.filter.pa_county && this.$scope.filter.pa_county === 'Region'){
      this.$scope.map.setFilter("countyLayer", null);
      this.$scope.showMoreFilters = false;
      // this.$scope.filter.jurisdiction = "";
     
      
      
    }
    
    if(this.$scope.filter.jurisdiction && this.$scope.filter.pa_county !== 'Region'){
      this.$scope.showMoreFilters = true;
      this.$scope.map.setFilter('sphereofinfluenceLayer', [
        "match",
        ["get", "jurname"],
        [this.$scope.filter.jurisdiction],
        true,
        false,
      ]);
    } else if(this.$scope.filter.pa_county === 'Region'){
      this.$scope.map.setFilter('sphereofinfluenceLayer', null);
    }

    // console.log(this.$scope.filter);

   
    this.$scope.filterLength = Object.keys(this.$scope.filter).length;
  }

  //Update map using filters
  updateMap() {
    
    document.getElementById("loader").style.visibility = "visible";



  

    var mapLoading = this.$scope.mapLoading;
    var map = this.$scope.map;
   
    var getDataFilterList = "$where=";

    this.$scope.rowCollection = [];
    // console.log(this.$scope.filter);
    var allFilter = [];
    allFilter.push("all");
    var operator;
    var filterKey;
    if(this.$scope.filter.density_operator){
      operator = this.$scope.filter.density_operator;
    }

    if(this.$scope.filter.impr_to_land_val_operator){
      operator = this.$scope.filter.impr_to_land_val_operator;
    }

    if(this.$scope.filter.parcel_size_operator){
      operator = this.$scope.filter.parcel_size_operator;
    }

    // console.log(_.has(this.$scope.filter, 'acres'));
    // if(_.has(this.$scope.filter, 'acres')){
    //   var acres = parseFloat(this.$scope.filter.acres);
    //   this.$scope.filter.acres = `acres${this.$scope.filter.parcel_size_operator}${acres}`;
    //   delete this.$scope.filter.parcel_size_operator;
    // }
    // console.log(this.$scope.filter);

    if(this.$scope.filter.pa_county && this.$scope.filter.pa_county !== 'Region'){
      this.$scope.url = (_.filter(this.$scope.countyClusterData,{county:this.$scope.filter.pa_county}))[0].dataset;
      console.log(this.$scope.url);
      this.$scope.params = 'geometry'
     } else {
      this.$scope.url = 'mtew-ft7m';
      this.$scope.params = 'geometry';
     }

    // Remove any false values from filter
    for (const key in this.$scope.filter) {
      if (this.$scope.filter.hasOwnProperty(key)) {
        if (this.$scope.filter[key] === false || this.$scope.filter[key] == null || this.$scope.filter[key] === 'null' || this.$scope.filter[key] === 'None') {
          delete this.$scope.filter[key];
        } else if (key === "pa_county" && this.$scope.filter[key] === "Region") {
           delete this.$scope.filter[key];
        } else if(key === 'density_operator' || key === 'impr_to_land_val_operator' || key === 'parcel_size_operator'){
        } else {
          console.log(key, " ", this.$scope.filter[key]);
          filterKey = this.$scope.filter[key];
          if(key === 'zn_max_dua' || key === 'impr_to_land_val' || key === 'acres'){
            allFilter.push([operator, key, parseFloat(filterKey)]);
          }
          else {
            allFilter.push(["==", key, filterKey]);
          }
         if(key !== 'density_operator' && key !== 'impr_to_land_val_operator' && key !== 'parcel_size_operator'){
          if (Object.keys(this.$scope.filter).length === 1) {
            if (key === "pa_county" || key === "jurisdiction" || key === 'zn_regional_description' || key === 'infrastructure_access' 
            || key === 'existing_land_use' || key === 'resource_lvl' || key === 'displacement_risk' || key === 'publicly_owned') {
              getDataFilterList += `${key}='${filterKey}'`;
            } else if(key === 'zn_max_dua' || key === 'impr_to_land_val' || key === 'acres'){
              console.log(key, operator, filterKey);
              getDataFilterList += `${key} ${operator} ${filterKey}`;
            } else {
              getDataFilterList += `${key}=${filterKey}`;
            }
          } else if (Object.keys(this.$scope.filter).length > 1) {
            if (key === "pa_county" || key === "jurisdiction" || key === 'zn_regional_description' || key === 'infrastructure_access' 
              || key === 'existing_land_use' || key === 'resource_lvl' || key === 'displacement_risk' || key === 'publicly_owned') {
              getDataFilterList += `${key}='${filterKey}' AND `;
            } else if(key === 'zn_max_dua' || key === 'impr_to_land_val' || key === 'acres'){
              console.log(key, operator, filterKey);
              getDataFilterList += `${key} ${operator} ${filterKey} AND `;
            } else {
              getDataFilterList += `${key}=${filterKey} AND `;
            }
          }
         }
        }
      }
    }
    // allFilter = ['all', ['==', 'pa_county', 'Alameda'], ['>=', 'zn_max_dua', 1]]

    // console.log(allFilter);

    //Remove last &
    if (Object.keys(this.$scope.filter).length > 1) {
      getDataFilterList = getDataFilterList.substring(
        0,
        getDataFilterList.length - 5
      );
    }
    // console.log(getDataFilterList);
    if(Object.keys(this.$scope.filter).length > 0){
      this.$scope.map.setFilter("ListLayer", allFilter);
     
      // console.log(this.$scope.map.getFilter('ListLayer'));
      this.$scope.listFilter = allFilter;
      this.$scope.getDataFilterList = getDataFilterList;
    } else {
      this.$scope.listFilter = [];
      this.$scope.getDataFilterList = '';
    }
    
    

     
     console.log(getDataFilterList);
      // console.log("running county query");
      console.log(
        `https://data.bayareametro.gov/resource/${this.$scope.url}.geojson?${getDataFilterList}&$select=geometry&$limit=250000`
      );

     this.$http.get(`https://data.bayareametro.gov/resource/${this.$scope.url}.geojson?${getDataFilterList}&$select=geometry&$limit=250000`)
     .then(response => {
      // this.$scope.map.off('render', loading);

      this.$scope.map
      .getSource('parcelClusters')
      .setData(response.data);

//       this.$scope.map.addLayer({
//         id: `clusters${this.$scope.filter.pa_county}`,
//         type: "circle",
//         source: `parcelClusters${this.$scope.filter.pa_county}`,
//         minzoom: 5,
//         maxzoom: 13,
//         filter: ["has", "point_count"],
//         paint: {
//           // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
//           // with three steps to implement three types of circles:
//           //   * Blue, 20px circles when point count is less than 100
//           //   * Yellow, 30px circles when point count is between 100 and 750
//           //   * Pink, 40px circles when point count is greater than or equal to 750
//           "circle-color": [
//             "step",
//             ["get", "point_count"],
//             "#800080",
//             1000,
//             "#800080",
//             10000,
//             "#800080",
//           ],
//           "circle-radius": [
//             "step",
//             ["get", "point_count"],
//             20,
//             100,
//             30,
//             2000,
//             40,
//           ],
//           "circle-opacity": 0.6,
//           "circle-stroke-color": "#ffffff",
//           "circle-stroke-width": 2,
//         },
//       });

//       this.$scope.map.addLayer({
//         id: `cluster-count${this.$scope.filter.pa_county}`,
//         type: "symbol",
//         source: `parcelClusters${this.$scope.filter.pa_county}`,
//         minzoom: 5,
//         maxzoom: 13,
//         filter: ["has", "point_count"],
//         layout: {
//           "text-field": ["get", "point_count_abbreviated"],
//           "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
//           "text-size": 12,
//         },
//         paint: {
//           "text-color": "#ffffff",
//         },
//       });

//       this.$scope.map.addLayer({
//         id: `unclustered-point${this.$scope.filter.pa_county}`,
//         type: "circle",
//         source: `parcelClusters${this.$scope.filter.pa_county}`,
//         minzoom: 5,
//         maxzoom: 13,
//         filter: ["!", ["has", "point_count"]],
//         paint: {
//           "circle-color": "#800080",
//           "circle-radius": 4,
//           "circle-stroke-width": 1,
//           "circle-stroke-color": "#fff",
//         },
//       });

// console.log(this.$scope.map.getLayer(`clusters${this.$scope.filter.pa_county}`));
// console.log(this.$scope.map.getSource(`parcelClusters${this.$scope.filter.pa_county}`))
     })
     .catch(err => {
      console.log(err);
     })
     
    
      // this.$scope.map.getSource(`parcelClusters${this.$scope.filter.pa_county}`).setData(this.$scope.emptyGeojson);
     
  
    var geo;
    console.log(this.$scope.filter.pa_county);
    console.log(this.$scope.filter.jurisdiction);
    if (this.$scope.filter.pa_county && this.$scope.filter.pa_county !== 'Region' && !this.$scope.filter.jurisdiction) {
      this.updateGeography(`${this.$scope.filter.pa_county} County`, "county");
    }
    if (this.$scope.filter.jurisdiction) {
      this.updateGeography(this.$scope.filter.jurisdiction, "jurisdiction");
    } else {
      this.updateGeography('Region','region');
    }
    // Close filters modal
    $("#newfiltersModal").modal("hide");
  }

  //Clear filters
  clearFilters() {
    this.$scope.filter = {};
    this.$scope.filterParcels = [];
    this.$scope.filterLength = 0;
    this.$scope.actionsLength = 0;
    this.$scope.jurisdictionList = [];
    this.$scope.showMoreFilters = false;

    // Turn off any map layers that are toggle on 
    this.turnOffAllLayers();

    this.$scope.filter = {
      in_cycle6: true
    };
    this.$scope.filter.pa_county = 'Region';
    console.log(this.$scope.countyList);
    console.log(this.$scope.filter);
    this.updateFilterLength();
    this.loadMap();

    //Reset multi selects
    // $("#znRegionalCodeSelect").val('default');
    // $("#znRegionalCodeSelect").selectpicker("refresh");

    // $("#znCodeSelect").val('default');
    // $("#znCodeSelect").selectpicker("refresh");

    this.$scope.rowCollection = [];

    // Set the filter to populate features into the layer.
    this.$scope.map.setFilter("parcels", null);
    this.$scope.map.setFilter('countyLayer', null);
    this.$scope.map.setFilter('sphereofinfluenceLayer',null);

    // this.$scope.map.setFilter("ListLayer", this.$scope.map.ListFilter);
    // this.$scope.map.setFilter('zoomParcelLayer', ["in", "parcel_id", ""]);
    if (this.$scope.map.getSource("zoomParcelSource")) {
      this.$scope.map.removeLayer("zoomParcelLayer");
      this.$scope.map.removeSource("zoomParcelSource");
    }
  }

  /**
   * @desc Opens appropriate update modal window based on parameters
   * @param {object} data - data loaded from value selected in the table
   * @param (string) crudType - type of update operation to perform (values: create, edit or delete)
   */
  zoomToSite(parcel) {
    //Open CRUD Modal
    console.log(parcel)
    // this.$scope.zoomSpinner = true;
    this.$scope.map.setZoom(16);
    this.$scope.map.setCenter(parcel.coordinates);

  }

  /**
   * @desc Opens appropriate update modal window based on parameters
   * @param {object} data - data loaded from value selected in the table
   * @param (string) crudType - type of update operation to perform (values: create, edit or delete)
   */
  openSiteEditModal(parcel_id) {
    this.$scope.parcel_id = parcel_id;
    console.log(this.lookup.getParcelDetail());
    //Open CRUD Modal
    if (parcel_id) {
      $("#siteSelectionModal").modal();
      this.$http.get(`https://data.bayareametro.gov/resource/nsv6-h4ws.json?$where=parcel_id='${parcel_id}'`,)
      .then(response => {
        console.log(response.data);
        this.$scope.hessParcel = response.data[0];
        //Create percentages and parse integers
        for (const key in this.$scope.hessParcel) {
          this.$scope.affhPercent.forEach(fieldName => {
            if (key === fieldName){
              console.log(key, ' ', fieldName);
              this.$scope.hessParcel[key] = parseInt(100 * this.$scope.hessParcel[key]);
              console.log(this.$scope.hessParcel[key]);
            }
          });
        
        }
        console.log(this.$scope.hessParcel);
      })
      .catch(err => {
        console.log(err);
      })


    }
  }

  //Open filters modal
  openFiltersModal() {
    //Refresh multi select inputs in case data hasn't yet loaded
    // setTimeout(function () {
    //   $('.selectpicker').selectpicker('refresh'); // refresh the selectpicker with fetched courses
    // }, 1000);
    $("#newfiltersModal").modal();
  }

  updateInfoBox(
    parcel_id,
    $http,
    $scope,
    dbFactory,
    coordinates,
    openSiteEditModalMoreInfo
  ) {
    var basicInfoPopup;
    // console.log(openSiteEditModalMoreInfo);
    $("#layersTabNav").removeClass("active");
    $("#myListTabNav").removeClass("active");
    $("#filtersTabNav").removeClass("active");
    $("#adminTabNav").removeClass("active");
    $("#selectedTabNav").addClass("active");

    $("#layersTabPanel").removeClass("active");
    $("#myListTabPanel").removeClass("active");
    $("#filtersTabPanel").removeClass("active");
    $("#adminTabPanel").removeClass("active");

  
    // console.log(coordinates);

    $http.get(`https://data.bayareametro.gov/resource/nsv6-h4ws.json?$where=parcel_id='${parcel_id}'`,)
    .then(response => {
      
      // console.log(response.data);
    })
    .catch(err => {
      console.log(err);
    })
  }

  addDataLayer($http, $scope, mapService, map) {
    // console.log($scope);
    //Function to manage toggling legend map layers [Map Service]
    mapService.updateHessToggles($scope);

    //    Add Parcels Source
    map.addSource("parcelsSource", {
      type: "vector",
      url: "mapbox://mtc-basis.hess_public_core", //Parcel Atlas (updated September 20 2021)
    });
    //Add jurisdiction boundary source
    map.addSource("jurisdictionBoundarySource", {
      type: "geojson",
      data: placesGeoJSON,
    });

    map.addLayer({
      id: "parcels",
      type: "fill",
      source: "parcelsSource",
      minzoom: 15,
      maxzoom: 21,
      "source-layer": "hess_public_core",
      paint: {
        "fill-outline-color": "black",
        "fill-color": "white",
        "fill-opacity": 0.4,
      },
    });

    console.log($scope.listFilter);
       // Add my sites
   if($scope.listFilter){
    map.addLayer({
      id: "ListLayer",
      type: "fill",
      source: "parcelsSource",
      minzoom: 12,
      maxzoom: 21,
      "source-layer": "hess_public_core",
      paint: {
        "fill-outline-color": "black",
        "fill-color": "#824086",
        "fill-opacity": 0.7,
      },
      filter: $scope.listFilter,
    });
   } else {
    map.addLayer({
      id: "ListLayer",
      type: "fill",
      source: "parcelsSource",
      minzoom: 12,
      maxzoom: 21,
      "source-layer": "hess_public_core",
      paint: {
        "fill-outline-color": "black",
        "fill-color": "#824086",
        "fill-opacity": 0.7,
      },
      filter: ["==", ["get", "in_cycle6"], true],
    });
   }


    //Jurisdiction Layer

    if (!map.getLayer("jurisdiction-boundary")) {
      map.addLayer({
        id: "jurisdiction-boundary",
        type: "line",
        source: "jurisdictionBoundarySource",
        paint: {
          "line-color": "black",
          "line-width": 2,
        },
        filter: ["in", "NAME", ""],
      });
    }

    var getDataFilterList = '';
    if($scope.getDataFilterList){
      console.log($scope.getDataFilterList);
      getDataFilterList = $scope.getDataFilterList;
    } else {
      getDataFilterList = '$where=in_cycle6=true';
    }
    // Add Cluster Layers 

    if(this.$scope.filter.pa_county && this.$scope.filter.pa_county !== 'Region'){
      this.$scope.url = (_.filter(this.$scope.countyClusterData,{county:this.$scope.filter.pa_county}))[0].dataset;
      console.log(this.$scope.url);
      this.$scope.params = 'geometry';
     } else {
      this.$scope.url = 'mtew-ft7m';
      this.$scope.params = 'geometry';
     }

      if(!$scope.map.getSource('parcelClusters')){
        $scope.map.addSource(`parcelClusters`, {
          type: "geojson",
          data: `https://data.bayareametro.gov/resource/${this.$scope.url}.geojson?${getDataFilterList}&$select=${this.$scope.params}&$limit=100000`,
          cluster: true,
          clusterMaxZoom: 16, // Max zoom to cluster points on
          clusterRadius: 50, // Radius of each cluster when clustering points (defaults to 50)
          tolerance: 0.5,
          buffer: 0,
          maxzoom: 18
        });
      }
      

      $scope.map.addLayer({
        id: `clusters`,
        type: "circle",
        source: `parcelClusters`,
        minzoom: 5,
        maxzoom: 13,
        filter: ["has", "point_count"],
        paint: {
        
          "circle-color": [
            "step",
            ["get", "point_count"],
            "#800080",
            1000,
            "#800080",
            10000,
            "#800080",
          ],
          "circle-radius": [
            "step",
            ["get", "point_count"],
            20,
            100,
            30,
            2000,
            40,
          ],
          "circle-opacity": 0.6,
          "circle-stroke-color": "#ffffff",
          "circle-stroke-width": 2,
        },
      });

      $scope.map.addLayer({
        id: `cluster-count`,
        type: "symbol",
        source: `parcelClusters`,
        minzoom: 5,
        maxzoom: 13,
        filter: ["has", "point_count"],
        layout: {
          "text-field": ["get", "point_count_abbreviated"],
          "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
          "text-size": 12,
        },
        paint: {
          "text-color": "#ffffff",
        },
      });

      $scope.map.addLayer({
        id: `unclustered-point`,
        type: "circle",
        source: `parcelClusters`,
        minzoom: 5,
        maxzoom: 13,
        filter: ["!", ["has", "point_count"]],
        paint: {
          "circle-color": "#800080",
          "circle-radius": 4,
          "circle-stroke-width": 1,
          "circle-stroke-color": "#fff",
        },
      });

     
            // inspect a cluster on click
    map.on('click', `clusters`, (e) => {
      const features = map.queryRenderedFeatures(e.point, {
      layers: [`clusters`]
      });
      const clusterId = features[0].properties.cluster_id;
      map.getSource(`parcelClusters`).getClusterExpansionZoom(
      clusterId,
      (err, zoom) => {
      if (err) return;

      
    // When a click event occurs on a feature in
    // the unclustered-point layer, open a popup at
    // the location of the feature, with
    // description HTML from its properties.
    map.on('click', `unclustered-point`, (e) => {
      const coordinates = e.features[0].geometry.coordinates.slice();
      console.log(e.features[0]);
      const mag = e.features[0].properties.jurisdiction;
      const tsunami =
      e.features[0].properties.in_cycle6 === "1.0" ? 'yes' : 'no';

      // Ensure that if the map is zoomed out such that
      // multiple copies of the feature are visible, the
      // popup appears over the copy being pointed to.
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }

      new mapboxgl.Popup()
      .setLngLat(coordinates)
      .setHTML(
      `Jurisdiction: ${mag}<br>Certified Site?: ${tsunami}`
      )
      .addTo(map.target);
      });

      map.on('mouseenter', `clusters`, () => {
      map.getCanvas().style.cursor = 'pointer';
      });
      map.on('mouseleave', `clusters`, () => {
      map.getCanvas().style.cursor = '';
      });

    });


    map.easeTo({
    center: features[0].geometry.coordinates,
    zoom: zoom
    });
    }
    );
 

    console.log(map.selectedFilter);
    if (!map.selectedFilter) {
      map.selectedFilter = ["in", "parcel_id", ""];
    }


    var layerData;
    var paint = {};
    var type;
    var filter;
    var sourceLayer;

    if (map.layerName) {
      console.log(map.layerName);
      var toggleStatus = map.layerName + "Toggle";
      for (let index = 0; index < $scope.mapLayers.length; index++) {
        const element = $scope.mapLayers[index];
        if (element.name === map.layerName) {
          console.log('match');
          console.log(map.getSource(element.source));
          if (map.getSource(element.source)) {
            visibility = map.getLayoutProperty(
              element.name,
              "visibility"
            );
            // toggle layer visibility by changing the layout object's visibility property
            if (visibility === "visible") {
              map.setLayoutProperty(element.name, "visibility", "none");
              $scope.visibleLayer = element.name;
              this.className = "";
            } else if (toggleStatus == false) {
              map.setLayoutProperty(element.name, "visibility", "none");
              $scope.visibleLayer = element.name;
              this.className = "";
            } else {
              this.className = "active";
              map.setLayoutProperty(
                element.name,
                "visibility",
                "visible"
              );
            }
            $scope.loadingDiv = false;
          } else {
            if(element.type === 'mapbox'){
              $http
              .get(element.url)
              .then((response) => {
                console.log(response.data);
                layerData = response.data;
                map.addSource(element.source, {
                  type: layerData.sources.composite.type,
                  url: layerData.sources.composite.url, //Parcel Atlas (updated September 15 2021)
                });
                
                  type = layerData.layers[0].type;
                  paint = layerData.layers[0].paint;
                  sourceLayer = layerData.layers[0]["source-layer"];
           
                 if(!map.getLayer(element.name)){
                  if (layerData.layers[0].filter) {
                    filter = layerData.layers[0].filter;
                    map.addLayer({
                      id: element.name,
                      type: layerData.layers[0].type,
                      source: element.source,
                      "source-layer": layerData.layers[0]["source-layer"],
                      paint: layerData.layers[0].paint,
                      filter: layerData.layers[0].filter
                    },'parcels');
                  } else {
                    map.addLayer({
                      id: element.name,
                      type: layerData.layers[0].type,
                      source: element.source,
                      "source-layer": layerData.layers[0]["source-layer"],
                      paint: layerData.layers[0].paint
                    },'parcels');
                  }
          
                 }
           
                if (!$scope[toggleStatus]) {
                  map.setLayoutProperty(
                    element.name,
                    "visibility",
                    "none"
                  );
                } else {
                  map.setLayoutProperty(
                    element.name,
                    "visibility",
                    "visible"
                  );
                }
                $scope.loadingDiv = false;
              })
              .catch((err) => {
                console.log(err);
              });
            } else if (element.type === "socrata") {
              map.addSource(element.source, {
                type: "geojson",
                data: element.url,
              });

              paint = element.paint;
              type = element.style;


              if(!map.getLayer(element.name)){
                map.addLayer(
                  {
                    id: element.name,
                    type: type,
                    source: element.source,
                    paint: paint
                  },
                  "parcels"
                );
              }
            }
          }
        } else {
          if (map.getSource(element.source)) {
            map.setLayoutProperty(element.name, "visibility", "none");
            $scope[element.name + "Toggle"] = false;
          }
        }
      }
    }
  }

  //Start clear selected function
  clearSelected() {
    // $('.mapboxgl-popup').remove();
    this.$scope.selectedRecords = [];
    this.$scope.removeRecords = [];
    this.$scope.addRecords = [];
    this.$scope.selectedParcels = [];
    this.$scope.rowSelectedCollection = [];
    var array1 = ["in", "parcel_id", ""];
    this.$scope.parcelSummary = null;

    this.$scope.map.selectedFilter = ["in", "parcel_id", ""];
    // this.$scope.map.setFilter("parcels-highlighted", array1);
  }
  //End clear selected function

}

export default angular.module('hessPublicApp.landusemap', [uiRouter])
  .config(routes)
  .component('landusemap', {
    template: require('./landusemap.html'),
    controller: LandusemapComponent,
    controllerAs: 'landusemapCtrl'
  })
  .directive("pageSelect", function () {
    return {
      restrict: "E",
      template: '<input type="text" class="select-page" ng-model="inputPage" ng-change="selectPage(inputPage)">',
      link: function (scope, element, attrs) {
        scope.$watch("currentPage", function (c) {
          scope.inputPage = c;
        });
      },
    };
  })
  .directive("stResetSearch", function () {
    return {
      restrict: "EA",
      require: "^stTable",
      link: function (scope, element, attrs, ctrl) {
        return element.bind("click", function () {
          return scope.$apply(function () {
            var tableState;
            tableState = ctrl.tableState();
            tableState.search.predicateObject = {};
            tableState.pagination.start = 0;
            return ctrl.pipe();
          });
        });
      },
    };
  })
  .directive("stFilteredCollection", function () {

    return {
      require: "^stTable",
      link: function (scope, element, attr, ctrl) {
        scope.$watch(ctrl.getFilteredCollection, function (val) {
          scope.filteredCollection = val;
        });
      },
    };
  }).name;



// WEBPACK FOOTER //
// ./client/app/landusemap/landusemap.component.js